import "./DataCard.css"

export default function ContactCard({
    title_card,
    title_1,
    title_2,
    title_3,
    title_4,
    value_1,
    value_2,
    value_3,
    value_4,
}) {
    return (
        <div className="contact-card">
            <h2 className="contact-card__title">
                {title_card}
            </h2>
            <div className="row">
                <div className="contact-card__item">
                    <span className="contact-card__label">
                        {title_1}
                    </span>

                    <strong className="contact-card__value">
                        {value_1}
                    </strong>
                </div>
                {title_2 && (<div className="contact-card__item with-padding">
                    <span className="contact-card__label">
                        {title_2}
                    </span>

                    <strong className="contact-card__value">
                        {value_2}
                    </strong>
                </div>)}
                {title_2 && (<div />)}
            </div >
            <div className="row">
                {title_3 && (<div className="contact-card__item">
                    <span className="contact-card__label">
                        {title_3}
                    </span>

                    <strong className="contact-card__value">
                        {value_3}
                    </strong>
                </div>)}
                {title_4 && (<div className="contact-card__item">
                    <span className="contact-card__label">
                        {title_4}
                    </span>

                    <strong className="contact-card__value">
                        {value_4}
                    </strong>
                </div>)}

            </div>
        </div >
    );
}